import { useContext } from 'react';
import { RootStore } from '../stores/RootStore';
import { RootContext } from '../contexts/StoreProvider';

/**
 *
 * @returns {RootStore} mobX global store context
 */
export const useStore = (): RootStore => useContext(RootContext);
